import {useEffect, useState} from "preact/hooks";
import type {XlsxRow, XlsxRowInput} from "./types.ts";
import {DateTime} from "luxon";
import {XLSX_URL} from "./env.ts";
import {throwIfInvalid} from "./utils.ts";

const _24HOURS = (1000 * 60 * 60 * 24);

export function useUIHistoric() {
    const [historic, setHistoric] = useState([] as XlsxRow[]);
    useEffect(() => {
        (async () => {
            const historicCached = JSON.parse(window.localStorage.getItem('historic-cache') ?? "null") as {
                cache: XlsxRowInput[],
                update: number
            } | null;
            if (historicCached !== null && (Date.now() - historicCached.update) < _24HOURS) {
                setHistoric(historicCached.cache.map(row => ({
                    date: throwIfInvalid(DateTime.fromISO(row.date)),
                    ui: row.ui
                })));
            } else {
                const xlsxHistoric = await fetch(XLSX_URL);
                const historic: XlsxRowInput[] = await xlsxHistoric.json();
                window.localStorage.setItem('historic-cache', JSON.stringify({
                    cache: historic,
                    update: Date.now(),
                }));
                setHistoric(historic.map(row => ({
                    date: throwIfInvalid(DateTime.fromISO(row.date)),
                    ui: row.ui
                }) as XlsxRow));
            }
        })()
    }, []);
    return historic;
}